import {
  MedicareBridgeChecklistItem,
  MedicareBridgeResponseValue,
} from './medicare-bridge.types';

export function reviewAnswerLines(
  items: MedicareBridgeChecklistItem[],
  responses: Record<string, MedicareBridgeResponseValue> | undefined,
): { key: string; label: string; value: string }[] {
  if (!responses) return [];
  return items.flatMap((item) => {
    const value = formatAnswer(item, responses[item.key]);
    return value ? [{ key: item.key, label: item.label, value }] : [];
  });
}

function formatAnswer(
  item: MedicareBridgeChecklistItem,
  value: MedicareBridgeResponseValue | undefined,
): string | null {
  if (value == null || value === '') return null;
  if (Array.isArray(value)) {
    if (value.length === 0) return null;
    return value
      .map(
        (entry) =>
          item.options?.find((option) => option.value === entry)?.label ??
          entry,
      )
      .join(', ');
  }
  if (typeof value === 'boolean') return value ? 'Met' : 'Not met';
  if (item.kind === 'CHOICE') {
    return (
      item.options?.find((option) => option.value === value)?.label ??
      String(value)
    );
  }
  return String(value);
}
